import React from "react";
import CV from "../../assets/CV/George Albert Abadir Saad CV.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a className="btn" href={CV} download target="_blank" rel="noreferrer">
        Download CV
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default CTA;
